import * as actionTypes from '../actions/actionTypes';
import { updateObject } from "../../lib/objectUtilities";

const initialState = {
  showMenu: false,
  showTooltip: null,
  showDialog: null,
  showCityDialog: null,
  showContentPopup: null,
  showResourcesStatistics: false,
  idle: false,
  error: null,
  typeHints: null
};

const toggleMenu = (state: any) => ({ ...state, showMenu: !state.showMenu });

const toggleResourceStats = (state: any) => ({
  ...state,
  showResourcesStatistics: !state.showResourcesStatistics
});

const openContentPopup = (state: any, action: any) => {
  const showContentPopup = (!state.showContentPopup
    || state.showContentPopup.name !== action.contentPopupOptions.name
    || action.contentPopupOptions.reload)
    && { ...action.contentPopupOptions };

  return !showContentPopup ? state : updateObject(state, {
    showContentPopup,
    showMenu: window && window.innerWidth < 768 ? false : state.showMenu
  });
};

const closeContentPopup = (state: any) => ({
  ...state,
  showDialog: null,
  showContentPopup: null,
  showTooltip: null,
  error: null
});

const openDialog = (state: any, action: any) => {
  // const showDialog = (!state.showDialog || state.showDialog.name !== action.dialogOptions.name)
  //   && { ...action.dialogOptions };
  //
  // // return !showDialog ? state : updateObject(state, { showDialog });
  // return !showDialog ? state : {
  //   ...state,
  //   showDialog
  // };

  const newDialog = state.showDialog && state.showDialog
    .some((options: any) => options.name === action.dialogOptions.name
      && (!action.dialogOptions.checkNotReload || action.dialogOptions.checkNotReload(options)))
    ? null : { ...action.dialogOptions };

  return !newDialog ? state : {
    ...state,
    showDialog: [
      ...((!action.dialogOptions.clear && state.showDialog && state.showDialog
        .filter((options: any) => options.name !== newDialog.name)) || []),
      newDialog
    ]
  };
}

const closeDialog = (state: any, { dialogName }: any) => {
  if (!dialogName || !state.showDialog
    || (state.showDialog.length === 1 && state.showDialog[0].name === dialogName)
  ) {
    return {
      ...state,
      showDialog: null
    }
  }

  return {
    ...state,
    showDialog: state.showDialog.filter((options: any) => options.name !== dialogName),
    error: null
  }
};

const openCityDialog = (state: any, action: any) => {
  const showCityDialog = { ...action.dialogOptions };

  return !showCityDialog ? state : updateObject(state, { showCityDialog });
}

const closeCityDialog = (state: any) => ({
  ...state,
  showCityDialog: null
});

const closeDialogs = (state: any) => ({
  ...state,
  showCityDialog: null,
  showDialog: null,
  showContentPopup: null
});

const openTooltip = (state: any, action: any) => {
  const newTooltip = state.showTooltip && state.showTooltip
    .some((options: any) => options.name === action.tooltipOptions.name)
    ? null : { ...action.tooltipOptions };

  return !newTooltip ? state : {
    ...state,
    showTooltip: [
      ...(state.showTooltip || []),
      newTooltip
    ]
  };
}

const closeTooltip = (state: any, { tooltipName }: any) => {
  if (!tooltipName || !state.showTooltip
    || (state.showTooltip.length === 1 && state.showTooltip[0].name === tooltipName)
  ) {
    return {
      ...state,
      showTooltip: null
    }
  }

  return {
    ...state,
    showTooltip: state.showTooltip.filter((options: any) => options.name !== tooltipName)
  }
};

const toggleIdleState = (state: any) => ({
  ...state,
  idle: !state.idle
});

const setError = (state: any, { error }: any) => ({
  ...state,
  error: error || null
});

const setTypeHints = (state: any, { typeHints }: any) => ({
  ...state,
  typeHints
});

const reducer = (state = initialState, action: any) => {
  switch (action.type) {
    case actionTypes.TOGGLE_MENU: return toggleMenu(state);
    case actionTypes.TOGGLE_RESOURCES_STATS: return toggleResourceStats(state);
    case actionTypes.OPEN_CONTENT_POPUP: return openContentPopup(state, action);
    case actionTypes.CLOSE_CONTENT_POPUP: return closeContentPopup(state);
    case actionTypes.OPEN_DIALOG: return openDialog(state, action);
    case actionTypes.CLOSE_DIALOG: return closeDialog(state, action);
    case actionTypes.OPEN_CITY_DIALOG: return openCityDialog(state, action);
    case actionTypes.CLOSE_CITY_DIALOG: return closeCityDialog(state);
    case actionTypes.CLOSE_DIALOGS: return closeDialogs(state);
    case actionTypes.OPEN_TOOLTIP: return openTooltip(state, action);
    case actionTypes.CLOSE_TOOLTIP: return closeTooltip(state, action);
    case actionTypes.TOGGLE_IDLE_STATE: return toggleIdleState(state);
    case actionTypes.SET_ERROR: return setError(state, action);
    case actionTypes.SET_TYPEHINT: return setTypeHints(state, action);
    default: return state;
  }
};

export default reducer;
